import { render, staticRenderFns } from "./another-profile.vue?vue&type=template&id=9e8e2af8&scoped=true&"
import script from "./another-profile.vue?vue&type=script&lang=js&"
export * from "./another-profile.vue?vue&type=script&lang=js&"
import style0 from "./another-profile.vue?vue&type=style&index=0&id=9e8e2af8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8e2af8",
  null
  
)

export default component.exports